import { RefinementCtx, ZodIssueCode } from 'zod';
import { Paths } from 'type-fest';
import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

import { ScheduleDatesFormData } from './types';

type Prefix = Extract<keyof ScheduleDatesFormData, `${string}AtDate` | `${string}AtTime`> extends
  | `${infer P}AtDate`
  | `${infer P}AtTime`
  ? P
  : never;

export const buildValidateDateAndTimeBothSet = (prefix: Prefix) => {
  return (data: ScheduleDatesFormData, ctx: RefinementCtx) => {
    const atDate: keyof ScheduleDatesFormData = `${prefix}AtDate`;
    const atTime: keyof ScheduleDatesFormData = `${prefix}AtTime`;

    if (!data[atDate] && data[atTime]) {
      ctx.addIssue({
        code: ZodIssueCode.custom,
        message: IS_REQUIRED,
        path: [`${prefix}AtDate` satisfies Paths<ScheduleDatesFormData>],
      });
    }

    if (data[atDate] && !data[atTime]) {
      ctx.addIssue({
        code: ZodIssueCode.custom,
        message: IS_REQUIRED,
        path: [`${prefix}AtTime` satisfies Paths<ScheduleDatesFormData>],
      });
    }
  };
};
